import { render, staticRenderFns } from "./AdminControlliView.vue?vue&type=template&id=966fc04e&"
import script from "./AdminControlliView.vue?vue&type=script&lang=ts&"
export * from "./AdminControlliView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports